import { AvatarFrame, FrameItem, Icon } from 'components';
import { useSpot } from 'hooks';
import { SpotLikeRegistParams, SpotListItem } from 'models';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { replacePathParams } from 'utils';
import { PATH } from 'uniforms';
import './SpotDetailUserInfo.scss';

interface SpotDetailUserProps {
    data: SpotListItem;
}

const sizeAvatarFrame = {
    layer1: 24,
    layer2: 23,
    avatar: 19,
};

const SpotDetailUserInfo = ({ data }: SpotDetailUserProps): JSX.Element => {
    const { postSpotLike } = useSpot();
    const [isLiked, setIsLiked] = useState<boolean>(false);
    const [likeCount, setLikeCount] = useState<number>(data?.spot_like_count);
    const navigate = useNavigate();

    const handleLikeSpot = useCallback((): void => {
        const params: SpotLikeRegistParams = {
            spot_id: data?.spot_id,
            spot_like_is_disabled: !isLiked ? 1 : 0,
        };
        postSpotLike({
            ...params,
            successCallback(data) {
                setIsLiked(!isLiked);
                setLikeCount(isLiked ? likeCount + 1 : likeCount - 1);
            },
        });
    }, [data?.spot_id, isLiked, likeCount, postSpotLike]);

    const handleGoToUserDetailPage = useCallback(
        (id: string) => (): void => {
            navigate(replacePathParams(PATH.USER.DETAIL, { id: id }));
        },
        [navigate],
    );

    useEffect(() => {
        let liked = data?.spot_like_is_disabled === 1 ? false : true;
        setIsLiked(liked);
        setLikeCount(data?.spot_like_count);
    }, [data?.spot_like_count, data?.spot_like_is_disabled]);

    return useMemo(
        () => (
            <FrameItem
                children={
                    <div className="spotdetail-user-info">
                        <div className="left-block">
                            <div className={'clear-status ' + (data?.spot_clear_status ? 'cleared' : 'not-clear')}>
                                {data?.spot_clear_status ? 'クリア済' : '未クリア'}
                            </div>
                            <div className="user-info" onClick={handleGoToUserDetailPage(data?.cognito_user_id || '0')}>
                                <div className="avatar-box">
                                    <AvatarFrame avatar={data?.avatar_url} size={sizeAvatarFrame} small={true} />
                                </div>
                                <div className="user-name">{data?.user_display_name}</div>
                            </div>
                        </div>
                        <div className="right-block">
                            <div className="icon" onClick={handleLikeSpot}>
                                {isLiked ? <Icon.LikeDisabled /> : <Icon.LikeActive />}
                            </div>
                            <span>{likeCount}</span>
                        </div>
                    </div>
                }
            />
        ),
        [data?.avatar_url, data?.spot_clear_status, data?.user_display_name, handleLikeSpot, isLiked, likeCount, handleGoToUserDetailPage],
    );
};

export default SpotDetailUserInfo;
